//Libs
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";

//Local

interface Props {
  // DIALOG BASICS
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactElement;
}

export default function ColumnDialog(props: Props) {
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
      <Dialog
        onClose={props.onClose}
        className="fixed inset-0 top-4 z-50 overflow-y-auto"
      >
        <div className="min-h-screen px-1 text-right xxs:px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 backdrop-blur-sm" />
          </Transition.Child>

          <span
            className="inline-block h-screen align-top"
            aria-hidden="true"
          ></span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={`inline-block w-full max-w-sm transform rounded-2xl border-2 border-gray-300 bg-white p-6 py-8 text-left align-middle shadow-xl transition-all`}
            >
              {props.children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
